import { ChartBoxoverEntry } from '../../../app/shared/components/ChartBoxover'
import { ApiPaginatedResponse } from '../../types'

export enum PastNextFuture {
  Past = 'Past',
  Next = 'Next',
  Future = 'Future',
}

export type RawEconomicEntry = {
  calendarId: number
  actual: string | null
  category: string
  date: string
  event: string
  forecast: string | null
  hasNoDetail: boolean
  importance: number | null
  isHigherPositive: number
  previous: string | null
  reference: string | null
  teforecast: string | null
  ticker: string
  alert: EconomicAlertEntry | null
  allDay: boolean
}

export type EconomicAlertEntry = {
  alertId: number
  onRelease: boolean
  remind5Min: boolean
  remind1Hour: boolean
  remind1Day: boolean
}

export type EconomicEntry = RawEconomicEntry & {
  isOpen: boolean
  parsedDate: Date
  type?: PastNextFuture
  isEmpty?: boolean
}

export type EconomicDayData = EconomicEntry[]

export type EconomicCalendarData = {
  days: EconomicDayData[]
}

export type RawCalendarData = {
  data: {
    entries: RawEconomicEntry[]
    initialDateFrom: string
  }
}

// -- Earnings --

export type EarningsEntryRaw = {
  earningsDate?: string
  isEarningDateEstimate?: boolean
  ticker: string
  epsEstimate?: number
  epsActual?: number
  epsSurprise?: number
  epsReportedEstimate?: number
  epsReportedActual?: number
  epsReportedSurprise?: number
  salesEstimate?: number
  salesActual?: number
  salesSurprise?: number
  oneDayPriceReaction?: number
  boxoverData?: ChartBoxoverEntry
}

export type EarningsEntry = EarningsEntryRaw & {
  parsedEarningsDate?: Date
}

export type RawEarningsData = {
  data: {
    entries: ApiPaginatedResponse<EarningsEntryRaw[]>
    initialDateFrom: string
    initialSort?: string
    initialPage: number
  }
}

// -- Dividends --

export type DividendsEntryRaw = {
  ticker: string
  company?: string
  exdate: string
  ordinary?: number
  special?: number
  yield?: number
  boxoverData?: ChartBoxoverEntry
}

export type DividendsEntry = DividendsEntryRaw & {
  parsedExDate: Date
}

export type RawDividendsData = {
  data: {
    entries: ApiPaginatedResponse<DividendsEntryRaw[]>
    initialDateFrom: string
    initialSort?: string
    initialPage: number
  }
}

// -- Economic Detail --

export type ChartDataItem = {
  actual: number
  estimate: number | null
  refDate: string
}

export type EconomicDetailData = {
  chartData: ChartDataItem[]
  description: string | null
  category: string
  frequency: number | null
  table: RawEconomicEntry[]
  ticker: string
  alert: EconomicAlertEntry | null
}

export type RawEconomicDetailData = {
  data: EconomicDetailData
}
